module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/decoration-dotted-hexagon-d79ac61767ccf92aedeec2424c858e66.svg";